/* pub-animations.js — port of Publisher (Dawn) assets/animations.js.
   Scoped: only elements inside a .pub-root subtree are ever observed, so this
   can never affect existing Kalles markup. Idempotent and Theme Editor safe. */
(function () {
  if (window.__pubAnimationsLoaded) return;
  window.__pubAnimationsLoaded = true;

  var TRIGGER = 'scroll-trigger';
  var OFFSCREEN = 'scroll-trigger--offscreen';
  var ZOOM = 'animate--zoom-in';
  var CANCEL = 'scroll-trigger--cancel';

  function throttle(fn) {
    var wait = false;
    return function () {
      if (wait) return;
      fn.apply(this, arguments);
      wait = true;
      window.requestAnimationFrame(function () { wait = false; });
    };
  }

  function scopedTriggers(rootEl) {
    var out = [];
    var roots = rootEl.classList && rootEl.classList.contains('pub-root')
      ? [rootEl]
      : Array.prototype.slice.call(rootEl.querySelectorAll('.pub-root'));
    roots.forEach(function (r) {
      if (r.classList.contains(TRIGGER)) out.push(r);
      Array.prototype.push.apply(out, r.getElementsByClassName(TRIGGER));
    });
    return out;
  }

  function onIntersection(elements, observer) {
    elements.forEach(function (element, index) {
      if (element.isIntersecting) {
        var t = element.target;
        if (t.classList.contains(OFFSCREEN)) {
          t.classList.remove(OFFSCREEN);
          if (t.hasAttribute('data-cascade')) t.setAttribute('style', '--animation-order: ' + index + ';');
        }
        observer.unobserve(t);
      } else {
        element.target.classList.add(OFFSCREEN);
        element.target.classList.remove(CANCEL);
      }
    });
  }

  function initScrollTriggers(rootEl, isDesignModeEvent) {
    rootEl = rootEl || document;
    var els = scopedTriggers(rootEl);
    if (!els.length) return;
    if (isDesignModeEvent) {
      els.forEach(function (el) { el.classList.add('scroll-trigger--design-mode'); });
      return;
    }
    var observer = new IntersectionObserver(onIntersection, { rootMargin: '0px 0px -50px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  function percentageSeen(element) {
    var viewportHeight = window.innerHeight;
    var scrollY = window.scrollY;
    var elementPositionY = element.getBoundingClientRect().top + scrollY;
    var elementHeight = element.offsetHeight;
    if (elementPositionY > scrollY + viewportHeight) return 0;
    if (elementPositionY + elementHeight < scrollY) return 100;
    var distance = scrollY + viewportHeight - elementPositionY;
    return Math.round(distance / ((viewportHeight + elementHeight) / 100));
  }

  function initZoom(rootEl) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    rootEl = rootEl || document;
    var roots = rootEl.classList && rootEl.classList.contains('pub-root')
      ? [rootEl]
      : Array.prototype.slice.call(rootEl.querySelectorAll('.pub-root'));
    var els = [];
    roots.forEach(function (r) { Array.prototype.push.apply(els, r.getElementsByClassName(ZOOM)); });
    if (!els.length) return;
    var scaleAmount = 0.2 / 100;

    // Publisher drives the zoom purely through the --zoom-in-ratio custom property
    // (`scale: var(--zoom-in-ratio)`). Some rendering engines do not resolve that
    // indirection for this element, which silently disabled the effect, so the ratio
    // is ALSO written straight onto the image. Same formula, same easing/duration
    // (the CSS transition), just a mechanism that actually applies everywhere.
    function applyRatio(element) {
      var ratio = 1 + scaleAmount * percentageSeen(element);
      element.style.setProperty('--zoom-in-ratio', ratio);
      var targets = element.querySelectorAll('img, .svg-wrapper');
      for (var n = 0; n < targets.length; n++) {
        targets[n].style.transform = 'scale(' + ratio + ')';
      }
    }

    els.forEach(function (element) {
      if (element.__pubZoomBound) return;
      element.__pubZoomBound = true;
      var visible = false;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { visible = e.isIntersecting; });
      });
      observer.observe(element);
      applyRatio(element);
      window.addEventListener('scroll', throttle(function () {
        if (!visible) return;
        applyRatio(element);
      }), { passive: true });
    });
  }

  function boot(root, designMode) {
    initScrollTriggers(root, designMode);
    initZoom(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document, false); });
  } else {
    boot(document, false);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { boot(e.target, true); });
    document.addEventListener('shopify:section:reorder', function () { boot(document, true); });
  }
})();
